// extracted by mini-css-extract-plugin
export default {"btnContainer":"UnConfirmShipment_btnContainer__QYsva","link":"UnConfirmShipment_link__m+7g6","dialog":"UnConfirmShipment_dialog__onVbk"};